export const MINIMUM_REQUIRED_KEE_CREDITS = 1
